// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Links-GatsbyLink-module--cls1--FDQb9","cls2":"Links-GatsbyLink-module--cls2--1V8U- Links-GatsbyLink-module--cls1--FDQb9"};